//
var fn_owl_carousel = function () {

  // > Slider-fw
  $('.owl-carousel.slider-fw').owlCarousel({
    items: 1,
    slideBy: 1,
    loop: false,
    rewind: false,
    nav: true,
    navText: ['<span class="sr-only">Précédent</span><span class="ikon-angle-long-right" aria-hidden="true"></span>', '<span class="sr-only">Suivant</span><span class="ikon-angle-long-right" aria-hidden="true"></span>'],
    navClass: ['btn btn-owl--prev', 'btn btn-owl--next'],
    // rewindNav: true,
    // stagePadding: 100,
    margin: 0,
    URLhashListener: true,
    autoplayHoverPause: true,
    startPosition: 'URLHash',
    responsiveClass: true
  })

  // > Slider-md-news
  // See: app.js coz slider is init or destroy based on RDW data

  // > Slider-half
  $('.owl-carousel.slider-half').owlCarousel({
    items: 1,
    slideBy: 1,
    loop: false,
    rewind: false,
    nav: false,
    navText: ['<span class="sr-only">Précédent</span><span class="ikon-angle-long-right" aria-hidden="true"></span>', '<span class="sr-only">Suivant</span><span class="ikon-angle-long-right" aria-hidden="true"></span>'],
    navClass: ['btn btn-owl--prev', 'btn btn-owl--next'],
    // rewindNav: true,
    margin: 0,
    URLhashListener: false,
    autoplayHoverPause: true,
    responsiveClass: true,
    responsive: {
      768: {
        nav: true
      }
    }
  })

  // > Slider-telex
  // > Using data-view MD / LG to set RWD - see also .attr('data-fruit','7');
  $('.owl-carousel.slider-telex').owlCarousel({
    items: 1,
    slideBy: 1,
    loop: false,
    rewind: false,
    nav: false,
    dots: true,
    navText: ['<span class="sr-only">Précédent</span><span class="ikon-angle-long-right" aria-hidden="true"></span>', '<span class="sr-only">Suivant</span><span class="ikon-angle-long-right" aria-hidden="true"></span>'],
    navClass: ['btn btn-owl--prev', 'btn btn-owl--next'],
    // rewindNav: true,
    margin: 0,
    URLhashListener: false,
    autoplayHoverPause: true,
    responsiveClass: true,
    responsive: {
      768: {
        items: $('.owl-carousel.slider-telex').attr("data-viewMd"), // 2,
        slideBy: $('.owl-carousel.slider-telex').attr("data-viewMd"), // 2,
        nav: true,
        dots: false
      },
      992: {
        items: $('.owl-carousel.slider-telex').attr("data-viewLg"), // 3,
        slideBy: $('.owl-carousel.slider-telex').attr("data-viewLg"), // 3,
        nav: true,
        dots: false
      }
    }
  })

  // > Slider-3views
  $('.owl-carousel.slider-3views').owlCarousel({
    items: 1,
    slideBy: 1,
    loop: false,
    rewind: false,
    nav: false,
    dots: true,
    navText: ['<span class="sr-only">Précédent</span><span class="ikon-angle-long-right" aria-hidden="true"></span>', '<span class="sr-only">Suivant</span><span class="ikon-angle-long-right" aria-hidden="true"></span>'],
    navClass: ['btn btn-owl--prev', 'btn btn-owl--next'],
    // rewindNav: true,
    margin: 0,
    URLhashListener: false,
    autoplayHoverPause: true,
    responsiveClass: true,
    responsive: {
      768: {
        items: 2,
        slideBy: 2,
        nav: false,
        dots: true
      },
      992: {
        items: 3,
        slideBy: 3,
        nav: false,
        dots: false
      }
    }
  })

  // > Slider-kfig
  // > Caution: requires owl.carousel-233.js as 234 is buggy with custom Dots content
  $('.owl-carousel.slider-kfig').on('initialized.owl.carousel changed.owl.carousel', function (e) {
    if (!e.namespace) {
      return
    }
    var index = e.item.index % e.item.count + 1
    $('.content-kfigures__counter').html('<b>' + index + '</b> / ' + e.item.count)
  // var carousel = e.relatedTarget
  // $('.content-kfigures__counter').text(carousel.relative(carousel.current()) + 1 + ' / ' + carousel.items().length)
  }).owlCarousel({
    // center: true,
    autoplay: true,
    loop: true,
    rewind: false,
    mouseDrag: true,
    touchDrag: true,
    nav: false,
    navText: ['<span class="sr-only">Précédent</span><span class="ikon-angle-long-right" aria-hidden="true"></span>', '<span class="sr-only">Suivant</span><span class="ikon-angle-long-right" aria-hidden="true"></span>'],
    navClass: ['btn btn-owl--prev', 'btn btn-owl--next'],
    // rewindNav: true,
    margin: 0,
    URLhashListener: false,
    autoplayHoverPause: true,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        slideBy: 1,
        nav: true,
        dotsData: true,
        dots: false,
        dotsEach: 1
      },
      667: {
        items: 2,
        slideBy: 2,
        nav: true,
        dotsData: true,
        dots: false,
        dotsEach: 2
      },
      768: {
        items: 3,
        slideBy: 3,
        nav: true,
        dotsData: true,
        dots: false,
        dotsEach: 3
      },
      992: {
        mouseDrag: false,
        touchDrag: false,
        items: 3,
        slideBy: 3,
        nav: false,
        dotsData: true,
        dots: true,
        dotsEach: 3
      }
    }
  })

// //
}
